import { getAPI, postAPI, putAPI } from "../../../../api/apis";
import { REACT_APP_CANDIDATE, REACT_APP_CANDIDATE_FREELANCER, REACT_APP_JOB, REACT_APP_PROFILE } from "../../../../utils/common";

export async function getDetails(Id: string | null){
    const Details = getAPI(REACT_APP_CANDIDATE +`/candidates/${Id}`)
    return Details
}

export async function getkExcistingEmail(email: string | null){
    const Details = getAPI( REACT_APP_CANDIDATE + `/email-duplicate-check/${email}`)
    return Details
}

export async function submitDetails(data: any){
    const Details = putAPI( REACT_APP_CANDIDATE_FREELANCER + `/candidate-profile`, data)
    return Details
}


export async function updateProfiles(data: any){
    const Resume = putAPI(REACT_APP_CANDIDATE , data)
    return Resume
}

export async function extractResume(data: any){
    const Resume = postAPI(REACT_APP_PROFILE + '/resume-details-ext', data)
    return Resume
}

export async function submitProfile(data: any){
    const Resume = putAPI(REACT_APP_CANDIDATE_FREELANCER + `/candidate-status`, data)
    return Resume
}

export async function getJobsForCandidate() {
    const Details = getAPI(REACT_APP_JOB + `/jobs`)
    return Details
}

export async function getTestDetails(jobId:string, loginId: string) {
    const Details = getAPI(REACT_APP_CANDIDATE_FREELANCER + `/test-details/${jobId}?loginId=${loginId}`)
    return Details
}

export async function saveReferedCandidateDetails(data: any) {
    const Details = postAPI(REACT_APP_CANDIDATE + '/referral-candidate', data)
    return Details   
}